<template>
  <v-container>
    <v-layout>
      <v-flex>
        <v-rules-table />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import VRulesTable from "./RulesTable";

export default {
  components: {
    VRulesTable
  }
};
</script>